import React from 'react';
import PropTypes from 'prop-types';
import ServiceProposal from "./ServiceProposal/ServiceProposal";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import appUserRoutes from "../../appUserRoutes";
import {TAB_SERVICE_PROPOSAL} from "../../views/UserViews/TecRmi/MainView";
import {useTecRmi} from "../../contexts/TecRmiContext";

const ServiceProposalTab = props => {
  const { ident, showType } = useTecRmi()
  return (
    <div>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tabModule(ident, TAB_SERVICE_PROPOSAL)}>Prace przeglądowe</BreadcrumbsItem>
      <ServiceProposal
        mileage={props.params[0] ? parseInt(props.params[0]) : null}
        firstRegistrationDate={props.params[1]}
        cooGroupId={props.params[2] ? parseInt(props.params[2]) : null}
        serviceProposalOption={props.params[3]}
        mainWorkId={props.params[4] ? parseInt(props.params[4]) : null}
        additionalWorkIds={props.params[5]?.split(',')?.map(id => parseInt(id))}
      />
    </div>
  );
};

ServiceProposalTab.defaultProps = {
  params: [],
};

ServiceProposalTab.propTypes = {
  params: PropTypes.array,
};

export default ServiceProposalTab;